import React from 'react'
import { FormattedMessage } from 'react-intl'

export const helpFaqMsg = (<FormattedMessage
  id="BookingsNavBar.helpFaq"
  description="Help / FAQ link in the header of checkout"
  defaultMessage="Help / FAQs"
/>)
